module.exports = __webpack_public_path__ + "media/images/icon/vision-f53960bce37f2943977d6cd3576a3691.png";